import React from 'react';
import { DKLabel, DKIcon, DKButton } from "deskera-ui-library";
import FormatCurrency from '../../SharedComponents/FormatCurrency';
import { TENANT, TenantService } from '../../managers/TenantManagerService';
import { COUNTRY } from '../../constants/CountryConstant';
import { isEmpty } from '../import_export/utility/ImportUtility';


const ShowProcessData = (props) => {

    const showElements = () => {
        let a
        if (props.data && props.data.length > 0) {
            {
                a = props['data'].map((comp, index) => {
                    return (
                        <div key={index} className="justify-content-between row m-v-s">
                            <DKLabel text={comp.name} className="fw-m" style={{ width: "30%" }} />
                            <DKLabel text={comp.type} className="text-gray" style={{ width: "20%" }} />
                            {
                                !isBenefitWithPercent(comp, 'employee') ? (
                                    <>
                                        <div style={{ width: "20%" }}>
                                            {!isEmpty(comp.amount) && <FormatCurrency amount={comp.amount} className="fw-m text-align-right" />}
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div style={{ width: "20%" }} className="fw-m text-align-right">
                                            {!isEmpty(comp.amount) && (<span> {comp.amount} %</span>)}
                                        </div>
                                    </>
                                )
                            }
                            {
                                !isBenefitWithPercent(comp, 'employer') ? (
                                    <>
                                        <div style={{ width: "20%" }}>
                                            {!isEmpty(comp.amount1) && <FormatCurrency amount={comp.amount1} className="fw-m text-align-right" />}
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div style={{ width: "20%" }} className="fw-m text-align-right">
                                            {!isEmpty(comp.amount1) && (<span> {comp.amount1} %</span>)}
                                        </div>
                                    </>
                                )
                            }

                            <div className={comp.defaultComponent ? ' w-45' : 'cursor-hand'} onClick={() => props.onButtonAction(index)} style={{ width: "10%", opacity: "0.6", textAlign: "right" }} >
                                {(isAllowDelete(comp)) && <DKIcon src={props.icon} className={'cursor-hand ic-s-2'} style={{ opacity: 0.8 }} />}
                            </div>
                        </div>
                    )
                })
            }
        }
        return a
    }

    const isBenefitWithPercent = (comp, type) => {

        if (comp.type != 'Benefit') {
            return false
        } else if (type === 'employee') {
            return comp.empType == 'percent'
        } else if (type === 'employer') {
            return comp.emprType == 'percent'
        }
    }

    const isAllowDelete = (comp) => {
        if (TenantService.get(TENANT.COUNTRY_CODE) === COUNTRY.IN && comp.defaultComponent && !props.isContractor) {
            switch (comp.name) {
                case 'Transport Allowance':
                case 'Commission':
                case 'Bonus':
                    return true;
                default:
                    return false;
            }
        } else {
            return true
        }
    }

    const getNoDataView = () => {
        return (
            <div>
                <DKLabel text="No data added" className="text-gray" />
            </div>
        );
    };

    return (
        <div>
            <DKLabel text={props.title} className="fw-m mt-l" />

            <div className="column justify-content-center align-items-center bg-gray1 border-radius-s mt-xs p-v-l p-h-m border-box parent-width">

                {showElements()}
                {props.data.length === 0 ? getNoDataView() : ""}
            </div>
            <div className="row-reverse">
                <DKButton
                    // title="+ Add "{props.title}"
                    title={`+ Add ` + props.title}
                    className="text-app bg-white fw-m "
                    onClick={(event) => {
                        props.onAddButton(event, props.title);
                    }}
                />
            </div>
        </div>

    );

}

export default ShowProcessData